/**
 * サンプルクラス
 * @constructor
 */
class Inview {

  constructor() {

    this._addClassNameval = 'is-inView';

    this.init();
  }


  init() {
    // 汎用系
    if (document.querySelector('.js-inView')) {
      this.makeObserver('.js-inView');
    }
    // 汎用系 ※下からフェードインで出現
    if (document.querySelector('.js-inView--aos')) {
      this.makeObserver_aos();
    }
    // TOPページのKV下の最新情報エリアの制御
    if (document.querySelector('.js-inView_news')) {
      this.makeObserver_news('.js-inView_news');
    }
    // ページTOPボタンの制御
    if (document.querySelector('.js-pagetop')) {
      // 新卒採用ページでは使用しない
      if (document.querySelector('.l-header--recruit')) {
        this.recruit_pageTop('.js-pagetop');
      } else {
        this.makeObserver_pageTop('.js-pagetop');
      }
    }
    this.makeObserver_header('.js-inView_header');
  }

  makeObserver(targetClassName) {
    const targetItem = document.querySelectorAll(targetClassName);
    const addClassNameval = this._addClassNameval;
    const options = {
      root: null,
      rootMargin: '-100px 0px',
      thresholdVal: 0
    };
    const observer = new IntersectionObserver(targetAddClass, options);
    targetItem.forEach(elem => observer.observe(elem));
    function targetAddClass (entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add(addClassNameval);
        } else {
          return false;
        }
      });
    }
  }

  makeObserver_aos() {
    // .js-inView--aosには_init.scssでopacity:0が定義されている
    const targetItem = document.querySelectorAll('.js-inView--aos');
    const options = {
      root: null,
      rootMargin: '-100px 0px',
      thresholdVal: 0
    };
    const observer_aos = new IntersectionObserver(aos_action, options);
    targetItem.forEach(elem => {
      const timeValue = elem.getAttribute('data-inView_aos-time');
      let aosTime;
      if (timeValue) {
        aosTime = timeValue;
      } else {
        aosTime = 0.5;
      }

      elem.style.position = 'relative'; // 要素のスタイルにposition: relativeを追加
      elem.style.transform = 'translate(0, 20px)'; // transform: translate(10px, 10px)を追加
      elem.style.transition = `all ${aosTime}s cubic-bezier(0.165, 0.84, 0.44, 1)`; // transitionを追加
      // elem.style.transition = 'all 0.5s cubic-bezier(0.165, 0.84, 0.44, 1)'; // transitionを追加

      // スタイル設定が完了してからobserveを呼び出す
      setTimeout(() => {
        observer_aos.observe(elem);
      }, 500);
    });
    function aos_action (entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.transform = 'translate(0, 0)';
          entry.target.style.opacity = '1';
        } else {
          return false;
        }
      });
    }
  }

  makeObserver_news(targetClassName) {
    // 要素の高さ（paddingTopの値）を取得
    const element = document.querySelector('.p-topAbout');
    const computedStyle = getComputedStyle(element);
    // const border = parseFloat(computedStyle.paddingTop);
    const border = 350;

    // 対象となる要素とオプションを準備
    const targetItem = document.querySelector(targetClassName);
    const target = document.body;
    const addClassNameval = this._addClassNameval;
    const makeObserver_news_options = {
      root: null,
      rootMargin: `${border}px 0px ${target.clientHeight}px 0px`,
      threshold: 1
    };

    // IntersectionObserverを生成して対象要素を監視
    const makeObserver_news_Observer = new IntersectionObserver(targetAddClass, makeObserver_news_options);
    makeObserver_news_Observer.observe(target);

    // コールバック関数: クラスの付け替えを行う
    function targetAddClass (entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // 要素が画面内に入った場合
          targetItem.classList.remove(addClassNameval); // クラスを削除
        } else {
          // 要素が画面外に出た場合
          targetItem.classList.add(addClassNameval); // クラスを追加
        }
      });
    }
  }

  makeObserver_header(targetClassName, borderNum = 50) {
    const border = borderNum;
    const targetItem = document.querySelector(targetClassName);
    const target = document.body;
    const addClassNameval = this._addClassNameval;
    const spHeaderScroll_options = {
      root: null,
      rootMargin: `${border}px 0px ${target.clientHeight}px 0px`,
      threshold: 1
    };
    const spHeaderScroll_Observer = new IntersectionObserver(targetAddClass, spHeaderScroll_options);
    spHeaderScroll_Observer.observe(target);

    function targetAddClass (entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          targetItem.classList.remove(addClassNameval);
        } else {
          targetItem.classList.add(addClassNameval);
        }
      });
    }
  }

  makeObserver_pageTop(targetClassName) {
    const border = 50;
    const targetItem = document.querySelector(targetClassName);
    const target = document.body;
    const addClassNameval = this._addClassNameval;
    const spHeaderScroll_options = {
      root: null,
      rootMargin: `${border}px 0px ${target.clientHeight}px 0px`,
      threshold: 1
    };
    const spHeaderScroll_Observer = new IntersectionObserver(targetAddClass, spHeaderScroll_options);
    spHeaderScroll_Observer.observe(target);

    function targetAddClass (entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          targetItem.classList.remove(addClassNameval);
        } else {
          targetItem.classList.add(addClassNameval);
          console.log(targetItem);
        }
      });
    }
  }

  recruit_pageTop() {
    const pageTopBtn = document.querySelector('.js-pagetop');
    window.addEventListener('scroll', () => {
      const scrollY = window.scrollY;
      if (scrollY > 50) {
        pageTopBtn.classList.add('is-inView');
      } else {
        pageTopBtn.classList.remove('is-inView');
      }
    });
  }
}

export default Inview;
